module.exports = __webpack_public_path__ + "9b6241dac03abce47d8d54b768ad62c8.svg";